var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-wrapper",class:{
    'main-wrapper--sidebar-closed': _vm.hideSidebar && _vm.hasSidebar,
    'main-wrapper--no-sidebar': !_vm.hasSidebar
  }},[_c('main',{class:{ 'container-fluid': _vm.useContainer }},[_c('div',{staticClass:"content-wrapper",class:{
        'content-wrapper--with-footer': _vm.showFooter,
        'content-wrapper--with-navbar': _vm.showNavbar
      }},[_vm._t("default")],2)]),_vm._v(" "),(!_vm.hideFooter)?_c('AppFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }